/**
 * Checks if a value is a number.
 *
 * @param {unknown} value - The value to check.
 * @returns {value is number} - True if the value is a number, false otherwise.
 */
export const isNumber = (value: unknown): value is number => {
  return typeof value === "number" && !isNaN(value);
};

/**
 * Converts a value to a number. If the value is not a number, returns 0.
 *
 * @param {unknown} value - The value to convert.
 * @returns {number} - The converted number, or 0 if the value is not a number.
 */
export const toNumber = (value: unknown): number => {
  const num = Number(value);
  return isNaN(num) || !value ? 0 : num;
};

export const toNumberOrNull = (value: unknown): number | null => {
  return value != null && value !== "" ? toNumber(value) : null;
};

export const formatNumber = (value: number | string): string => {
  try {
    if (typeof value === "string") {
      const sValue = Number(value);
      return `${sValue.toLocaleString("en-GB")}`;
    }
    return `${value.toLocaleString("en-GB")}`;
  } catch {
    return value.toString();
  }
};
